'use strict';

angular.module('shiftTraderApp')
  .factory('SAErrorHandler', function ($injector) {
    var handler = {};
    var standardErrorMessage = 'Oops! We had an issue... Try again later.';
    var toastr = $injector.get('toastr')

    handler.RequestOutsideOfPermissionsCode = 160;

    handler.AccessDeniedCode = 1002;

    handler.processError = function(response, optionalDefaultMessage) {
      var theMessage = '';

      if (_.has(response.data, 'message')) {
        var code = response.data.message.split('|');
        if (code.length >= 2) {
          code = Number(code[0]);
        } else {
          code = 999999; // this will hit default case
        }

        switch(code) {
        case 104: // ApiError::NotAllowedOrWrongData
          theMessage = standardErrorMessage;
          break;
        case 100: // ApiError::ReferencedRecordNotFound
          theMessage = 'Entry could not be found';
          break;
        case 102: // ApiError::AcceptanceCodeNotAllowed
          theMessage = 'Response type not allowed!';
          break;
        case 111: // ApiError::IncorrectAcceptanceCode
          theMessage = 'Response type not allowed!';
          break;
        case 105: // ApiError::CreateFailed
          theMessage = 'Sorry! Creation failed.  Try again.';
          break;
        case 106: // ApiError::TradeInactiveError
          theMessage = 'Response not allowed. Trade is inactive!';
          break;
        case 107: // ApiError::WorkPeriodIsLocked
          theMessage = 'Action not allowed. Shift is locked!';
          break;
        case 108: // ApiError::WorkPeriodAlreadyBeingTraded
          theMessage = 'Cannot create trade. Shift already being traded.';
          break;
        case 109: // ApiError::WorkPeriodsInactive
          theMessage = 'Cannot create trade. One of the shifts is inactive';
          break;
        case 110: //OrganizationIdRequired
          theMessage = standardErrorMessage;
          break;
        case 112: //CannotChangeWorkPeriodUser
          theMessage = 'Cannot change the user of this shift.';
          break;
        case 113: //InvalidDateProvided
          theMessage = 'Invalid date provided. Is it in the past?';
          break;
        case 114: //DepartmentNameAlreadyTaken
          theMessage = 'Department name already taken.';
          break;
        case 115: //PositionNameAlreadyTaken
          theMessage = 'Position name already taken. Please try another.';
          break;
        case 130: //AvailabilityRuleInactive
          theMessage = 'Availability rule was already inactive';
          break;
        case 131: //AvailabilityRuleNotPending
          theMessage = 'Availability rule was already approved or disapproved';
          break;
        case 132: //ShiftTradeAlreadyExists
          theMessage = 'You already have an active shift trade for this shift.';
          break;
        case 133:
          theMessage = 'You must be an active employee in this company to do that.';
          break;
        case 134:
          theMessage = 'Pay rate is not a valid number. Please check the field.';
          break;
        case 22: //UserEmailAlreadyExists
          theMessage = 'Email address already exists for a user in Shift Agent. Have you already added them? Do they work at another store?';
          break;
        case 140:
          theMessage = 'You have requested this user\'s contact info too many times in the last 2 weeks. Try again later.';
          break;
        case 141:
          theMessage = 'Requested user has no contact info.';
          break;
        case 142:
          theMessage = 'You recently requested this user\'s contact info. Try again later.';
          break;
        case 143:
          theMessage = 'Cannot send request. Requested user has not activated yet.';
          break;
        case 144:
          theMessage = 'Cannot respond to trade. You are inactive in this organization.';
          break;
        case 149:
          theMessage = 'Trade cannot be responded to because a Work Period is inactive.';
          break;
        case 150:
          theMessage = 'Trade cannot be responded to because it is already approved.';
          break;
        case 151:
          theMessage = 'ReferralAction action not accepted.';
          break;
        case 152:
          theMessage = 'ReferralAction not found.';
          break;
        case 153:
          theMessage = 'An organization already exists linked to this referral code.';
          break;
        case 154:
          theMessage = 'Text contains obscene language. Please remove it and submit again.';
          break;
        case 155:
          theMessage = 'This store has already been referred to by your store.';
          break;
        case 156:
          theMessage = 'This store has already signed up.';
          break;
        case 157:
          theMessage = 'Referral quota has been exceeded for this time period.';
          break;

        case 160:
          theMessage = 'Sorry. This request is outside of your organization permissions.';
          break;
        case 170:
          theMessage = 'Shift must start in the future. Please adjust the start time and try again.';
          break;
        case 171:
          theMessage = 'Shift must end after it starts. Please adjust the times and try again.';
          break;
        case 172:
          theMessage = 'We were unable to purchase your tokens.';
          break;
        case 173:
          theMessage = 'We had an issue purchasing your token. Please contact Shift Agent support.';
          break;
        case 174:
          theMessage = 'There is no credit card on file. Please contact Shift Agent support.';
          break;
        case 1010:
          theMessage = 'Your store is now on the Shift Agent Basic plan. Please contact your manager for your schedule.';
        case 1012:
          theMessage = 'You need an override token to be able to make this request. Please contact your manager.'
        default:
          theMessage = standardErrorMessage;
        }
      } else {
        if (response.status === 400) {
          theMessage = standardErrorMessage;
        } else {
          theMessage = 'Well, that was unexpected...';
        }
      }

      if (optionalDefaultMessage && theMessage === standardErrorMessage) {
        theMessage = optionalDefaultMessage;
      }

      toastr.error(theMessage, 'Error');
    };

    return handler;
  });
